/* eslint-disable no-restricted-globals */
/* eslint-disable no-unused-vars */
/* eslint-disable max-len */
/* eslint-disable import/no-extraneous-dependencies */
import Vue from 'vue';
import Vuex from 'vuex';
import axios from 'axios';
import router from '@/router/index';
import { UseBrowserLocation } from '@vueuse/components';

Vue.use(Vuex);

const base = process.env.VUE_APP_SERVER;

function initialState() {
  return {
    prospectPacket: null,
    benefitsPacket: null,
    loggedInUser: {
      name: null,
      email: null,
      impersonated: false,
    },
    signatureRequestEmail: null,
    auditLog: {
      message: '',
      data: '',
      errorCode: '',
      companyPacketGuid: '',
    },
    btnSignAndReviewLoading: false,
    btnInviteProspectLoading: false,
    btnInviteResendLoading: false,
    snackbar: {
      message: '',
      show: false,
    },
    validated: false,
    docSignDialog: true,
    docSignEmail: null,
    docSignErrorMessage: null,
    docSignSuccessful: false,
    sendSignatureDialog: false,
    benifitsSignBtn: false,
    themes: {
      light: {
        iconBg: '#E0E0E0',
        gradient: 'linear-gradient(to right, #ffffff, #F5F5F5)',
      },
      dark: {
        iconBg: '#292b3a',
        gradient: 'linear-gradient(to right, #1a1b26, #262837)',
      },
    },
    stepper: {
      currentStep: 0,
    },
    benefitsStepper: {
      currentStep: 0,
    },
    corporationTypes: [
      'S-Corp',
      'C-Corp',
      'Partnership',
      'Sole Proprietorship',
      'Non-Profit',
      'LLC',
    ],
    benefitClasses: [],
    cobraEmployees: [],
    electionEmployees: [],
    prospects: [],
    signedDocuments: [],
    datatable: {
      headers: [
        {
          text: 'BC Name',
          align: 'start',
          sortable: false,
          value: '',
          groupable: false,
        },
        { text: 'Prospect FirstName', value: 'firstName', align: ' d-none' },
        { text: 'Prospect LastName', value: 'lastName', align: ' d-none' },
        { text: 'BC Name', value: 'invitedByName', align: ' d-none' },
        { text: 'Name', value: 'fullName' },
        { text: 'Email', value: 'email' },
        { text: 'Title', value: 'userTitle' },
        { text: 'Created', value: 'userCreationDate' },
        { text: 'Actions', value: 'actions', sortable: false },
        { text: '', value: 'data-table-expand' },

        // { text: 'Company Name', value: 'companyName' },
        // { text: 'Prospect Status', value: 'prospect_Status', filterable: false },
        // { text: 'Benefit Status', value: 'benefit_Status', filterable: false },
      ],
    },
    auditLogDataTable: {
      headers: [
        {
          text: 'Id',
          align: 'start',
          sortable: false,
          value: 'id',
          groupable: false,
        },
        { text: 'Message', value: 'message', sortable: false },
        { text: 'BC', value: 'bc', sortable: false },
        { text: 'Prospect', value: 'prospect', sortable: false },
        { text: 'Date', value: 'date', sortable: false },
      ],
    },
    auditLogData: [
      {
        id: 0,
        message: '',
        bc: '',
        prospect: '',
        date: '',
      },
    ],
    standard: {
      temp: null,
    },
    benefits: {
      temp: null,
    },
    prospectLoginCreds: {
      email: '',
      password: '',
      remember: false,
      loading: false,
    },
    prospectLoginToken: null,
    prospectLoginErrorDialog: false,
    prospectLoginErrorResponse: null,
    prospectUserInvitation: {
      FirstName: null,
      LastName: null,
      Email: [],
      Title: null,
      Company: null,
      Message: null,
    },
    prospectUserInvitationErrorDialog: false,
    prospectUserInvitationErrorResponse: null,
    validationGuid: null,
    setPassword: null,
    setPasswordErrorDialog: false,
    setPasswordErrorDialogResponse: null,
    userInfo: {
      userInfoDialog: false,
      packetGuid: null,
      documents: [],
      impersonated: false,
    },
    forgotPasswordDialog: false,
    forgotPasswordResponse: null,
    signatureSkeletonLoader: true,
    userCompanies: [],
    companyChooserDialog: false,
    fileSizeDialog: false,
    showHints: true,
    showBenefitsTutorial: false,
    companyStatus: {},
  };
}

const localStore = new Vuex.Store({
  state: initialState,
  mutations: {
    reset(state) {
      const s = initialState();
      Object.keys(s).forEach((key) => {
        state[key] = s[key];
      });
    },
    updateDocSignEmail(state, value) {
      state.docSignEmail = value;
    },
    updateDocSignDialog(state, value) {
      state.docSignDialog = value;
    },
    updateDocSignErrorMessage(state, value) {
      state.docSignErrorMessage = value;
    },
    updateDocSignSuccessful(state, value) {
      state.docSignSuccessful = value;
    },
    updateSendSignatureDialog(state, value) {
      state.sendSignatureDialog = value;
    },
    updateCompanyStatus(state, value) {
      state.companyStatus = value;
    },
    updateAuditLog(state, value) {
      state.auditLog = value;
    },
    updateUserDocuments(state, value) {
      state.benefitsPacket.documents = value;
      state.prospectPacket.documents = value;
    },
    updateShowHints(state, value) {
      state.showHints = value;
      localStorage.setItem('showHints', value);
    },
    updateShowBenefitsTutorial(state, value) {
      state.showBenefitsTutorial = value;
    },
    updateFileSizeDialog(state, value) {
      state.fileSizeDialog = value;
    },
    updateUserCompanies(state, value) {
      state.userCompanies = value;
    },
    updateCompanyChooserDialog(state, value) {
      state.companyChooserDialog = value;
    },
    updateSignatureSkeletonLoader(state, value) {
      state.signatureSkeletonLoader = value;
    },
    updateAuditLogs(state, value) {
      state.auditLogData = value;
    },
    toggleAdminProspectBtnLoading(state, value) {
      const prospect = state.prospects.find((x) => x.packetGuid === value.packetGuid);
      prospect.loading = !prospect.loading;
    },
    UpdateBtnInviteResendLoading(state, value) {
      state.btnInviteResendLoading = value;
    },
    updateSignedDocuments(state, value) {
      state.signedDocuments = value;
    },
    updatedUserInfoImpersonatedFlag(state, value) {
      state.userInfo.impersonated = value;
    },
    updateBtnInviteProspectLoading(state, value) {
      state.btnInviteProspectLoading = value;
    },
    updateSignatureRequestEmail(state, value) {
      state.signatureRequestEmail = value;
    },
    updateBenefitsSignAndReviewBtn(state, value) {
      state.benifitsSignBtn = value;
    },
    updateBtnSignAndReviewLoading(state, value) {
      state.btnSignAndReviewLoading = value;
    },
    updateUserInfoPacketGuid(state, value) {
      state.userInfo.packetGuid = value;
    },
    updateUserInfoDocuments(state, value) {
      state.userInfo.documents = value;
    },
    updateUserInfoDialog(state, value) {
      state.userInfo.userInfoDialog = value;
    },
    updateLoggedInUser(state, value) {
      state.loggedInUser = value;
    },
    updateSnackbarShow(state, value) {
      state.snackbar.show = value;
    },
    updateSnackbarMessage(state, value) {
      state.snackbar.message = value;
    },
    updateValidation(state, value) {
      state.validated = value;
    },
    updateValidationGuid(state, value) {
      state.validationGuid = value;
    },
    goToStep(state, value) {
      state.stepper.currentStep = value;
    },
    benefitsGoToStep(state, value) {
      state.benefitsStepper.currentStep = value;
    },
    addBenefitClass(state, value) {
      state.benefitClasses.push(value);
    },
    removeBenefitClass(state, value) {
      state.benefitClasses.splice(value, 1);
    },
    updateBenefitClass(state, value) {
      state.benefitClasses = value;
    },
    updateElectionEmployees(state, value) {
      state.electionEmployees = value;
    },
    updateAdminProspects(state, value) {
      state.prospects = value;
    },
    updateProspectLoginCreds(state, value) {
      state.prospectLoginCreds = value;
    },
    updateProspectLoginEmail(state, value) {
      state.prospectLoginCreds.email = value;
    },
    updateProspectLoginPassword(state, value) {
      state.prospectLoginCreds.password = value;
    },
    updateProspectLoginLoading(state, value) {
      state.prospectLoginCreds.loading = value;
    },
    updateProspectLoginRemember(state, value) {
      state.prospectLoginCreds.remember = value;
    },
    updateProspectLoginToken(state, value) {
      state.prospectLoginToken = value;
    },
    updateProspectLoginErrorDialog(state, value) {
      state.prospectLoginErrorDialog = value;
    },
    updateProspectLoginErrorResponse(state, value) {
      state.prospectLoginErrorResponse = value;
    },
    updateProspectUserInvitation(state, value) {
      state.prospectUserInvitation = value;
    },
    updateProspectUserInvitationErrorDialog(state, value) {
      state.prospectUserInvitationErrorDialog = value;
    },
    updateProspectUserInvitationErrorResponse(state, value) {
      state.prospectUserInvitationErrorResponse = value;
    },
    updateSetPassword(state, value) {
      state.setPassword = value;
    },
    updateSetPasswordErrorDialog(state, value) {
      state.setPasswordErrorDialog = value;
    },
    updateSetPasswordErrorDialogResponse(state, value) {
      state.setPasswordErrorDialogResponse = value;
    },
    updateBenefitsDocuments(state, value) {
      state.benefitsPacket.documents = value;
    },
    updateProspectDocuments(state, value) {
      state.prospectPacket.documents = value;
    },
    // <---- Prospect ---->
    updateProspectPacket(state, value) {
      state.prospectPacket = value;
    },
    // <---- Prospect.State ---->
    updateProspectStateStep(state, value) {
      state.prospectPacket.state.step = value;
    },
    updateProspectStateStatus(state, value) {
      state.prospectPacket.state.status = value;
    },
    // <---- Prospect.PEO ---->
    updateProspectPEOFlag(state, value) {
      state.prospectPacket.flags.workingWithPEO = value;
    },
    updatePEOCompanyName(state, value) {
      state.prospectPacket.peo.name = value;
    },
    updatePEODate(state, value) {
      state.prospectPacket.peo.effectiveDate = value;
    },
    // <---- Prospect.CompanyInfo ---->
    updateCompanyOwnerNames(state, value) {
      state.prospectPacket.companyInfo.ownerNames = value;
    },
    updateCompanyLegalName(state, value) {
      state.prospectPacket.companyInfo.legalName = value;
    },
    updateCompanyLegalNameAlt(state, value) {
      state.prospectPacket.companyInfo.legalNameAlt = value;
    },
    updateCompanyYearsInBusiness(state, value) {
      state.prospectPacket.companyInfo.yearsInBusiness = value;
    },
    updateCompanyYearsAtLocation(state, value) {
      state.prospectPacket.companyInfo.yearsAtLocation = value;
    },
    updateCompanyDescription(state, value) {
      state.prospectPacket.companyInfo.descriptionOfOperations = value;
    },
    updateFedId(state, value) {
      state.prospectPacket.companyInfo.fedId = value;
    },
    updateCorporationType(state, value) {
      state.prospectPacket.companyInfo.corporationType = value;
    },
    updateContactObject(state, value) {
      let contact = state.prospectPacket.contacts.find((x) => x.contactType === value.contactType);
      contact = value;
    },
    updateEmployeeWorkStates(state, value) {
      state.prospectPacket.companyInfo.employeeWorkStates = value;
    },
    updateCompanySSN(state, value) {
      state.prospectPacket.companyInfo.ssn = value;
    },
    updateOwnerDOB(state, value) {
      state.prospectPacket.companyInfo.ownerDOB = value;
    },
    updateCompanyDate(state, value) {
      state.prospectPacket.companyInfo.date = value;
    },
    // <---- Prospect.OfficeLocations ---->
    updateOfficeLocations(state, value) {
      state.prospectPacket.officeLocations = value;
    },
    // <---- Prospect.Flags ---->
    updateHasMultipleOfficeLocations(state, value) {
      state.prospectPacket.flags.officeLocations = value;
    },
    updateHasDeliquency(state, value) {
      state.prospectPacket.flags.hasDelinquency = value;
    },
    updateHasCollections(state, value) {
      state.prospectPacket.flags.hasCollections = value;
    },
    UpdateHasBenefitPacket(state, value) {
      state.prospectPacket.flags.hasBenefitPacket = value;
    },
    updateLegalMixFlag(state, value) {
      state.prospectPacket.flags.legalMix = value;
    },
    // <---- Prospect.PayrollInformation ---->
    updateEmployeePayrollInfo(state, value) {
      state.prospectPacket.payrollInformation.employees = value;
    },
    updateOwnerPayrollInfo(state, value) {
      state.prospectPacket.payrollInformation.owners = value;
    },
    // <---- Prospect.BankInformation ---->
    updateBankName(state, value) {
      state.prospectPacket.bankInformation.bankName = value;
    },
    updateAccountNumber(state, value) {
      state.prospectPacket.bankInformation.accountNumber = value;
    },
    updateCollectionExplanation(state, value) {
      state.prospectPacket.bankInformation.collectionExplanation = value;
    },
    updateDelinquencyExplanation(state, value) {
      state.prospectPacket.bankInformation.delinquencyExplanation = value;
    },
    updateLegalMixExplanation(state, value) {
      state.prospectPacket.bankInformation.legalMixExplanation = value;
    },
    // <---- Prospect.TaxPreparer ---->
    updateFirmName(state, value) {
      state.prospectPacket.taxPreparer.firmName = value;
    },
    // <---- Prospect.Contacts ---->
    updateProspectContacts(state, value) {
      state.prospectPacket.contacts = value;
    },
    // <---- Prospect.Signature ---->
    updateProspectSignature(state, value) {
      state.prospectPacket.signature = value;
    },
    // <---- Benefits ---->
    updateBenefitsPacket(state, value) {
      state.benefitsPacket = value;
    },
    // <---- Benefits.Contact ---->
    updateBenefitsContact(state, value) {
      state.benefitsPacket.contact = value;
    },
    // <---- Benefits.State ---->
    updateBenefitsStateStep(state, value) {
      state.benefitsPacket.state.step = value;
    },
    updateBenefitsStateStatus(state, value) {
      state.benefitsPacket.state.status = value;
    },
    // <---- Benefits.Employees ---->
    updateBenefitsEmployees(state, value) {
      state.benefitsPacket.employees = value;
    },
    // <---- Benefits.Pregnancies ---->
    updateBenefitsPregnancies(state, value) {
      state.benefitsPacket.pregnancies = value;
    },
    // <---- Benefits.Flags ---->
    updateBenefitsAlreadyProvided(state, value) {
      state.benefitsPacket.flags.benefitsAlreadyProvided = value;
    },
    updatePlanCancelledOrDenied(state, value) {
      state.benefitsPacket.flags.planCancelledOrDenied = value;
    },
    updateChangedInsurers(state, value) {
      state.benefitsPacket.flags.changedInsurers = value;
    },
    updateEmployeesOnCobra(state, value) {
      state.benefitsPacket.flags.employeesOnCobra = value;
    },
    updateEmployeesinCobraElectionPeriod(state, value) {
      state.benefitsPacket.flags.employeesinCobraElectionPeriod = value;
    },
    updateCurrentEmployeesExceeding10k(state, value) {
      state.benefitsPacket.flags.currentEmployeesExceeding10k = value;
    },
    updatePreExistingChronicCondition(state, value) {
      state.benefitsPacket.flags.preExistingChronicCondition = value;
    },
    updateMaintenanceMedications(state, value) {
      state.benefitsPacket.flags.maintenanceMedications = value;
    },
    updateAvisedToHaveSurgery(state, value) {
      state.benefitsPacket.flags.advisedToHaveSurgery = value;
    },
    updateConfinedForTreatment(state, value) {
      state.benefitsPacket.flags.confinedForTreatment = value;
    },
    updateCurrentPregnancies(state, value) {
      state.benefitsPacket.flags.currentPregnancies = value;
    },
    updateChronicMissingDays(state, value) {
      state.benefitsPacket.flags.chronicMissingDays = value;
    },
    updateBenefitsRenewalRate(state, value) {
      state.benefitsPacket.flags.renewalRates = value;
    },
    updateClaimsExperience(state, value) {
      state.benefitsPacket.flags.claimsExperience = value;
    },
    updateDisabilityLast5Years(state, value) {
      state.benefitsPacket.flags.disability5Years = value;
    },
    updateHospitalizedByDisability(state, value) {
      state.benefitsPacket.flags.hospitalizedByDisability = value;
    },
    updateAdvisedForTreatment(state, value) {
      state.benefitsPacket.flags.advisedForTreatment = value;
    },
    // <---- Benefits.Providers ---->
    updateBenefitsProviders(state, value) {
      state.benefitsPacket.providers = value;
    },
    updateBenefitProviderHealth(state, value) {
      state.benefitsPacket.providers.health = value;
      state.benefitsPacket.currentHealthCarrier.carrierName = value;
    },
    // <---- Benefits.CurrentHealthInsurance ---->
    updateCurrentHealthCarrier(state, value) {
      state.benefitsPacket.currentHealthCarrier = value;
    },
    updateSelfFunded(state, value) {
      state.benefitsPacket.currentHealthCarrier.selfFunded = value;
    },
    // <---- Benefits.GeneralInfo ---->
    updateGeneralInfo(state, value) {
      state.benefitsPacket.generalInfo = value;
    },
    updateCurrentEmployeesExceeding10kExplanation(state, value) {
      state.benefitsPacket.generalInfo.currentEmployeesExceeding10kExplanation = value;
    },
    updatePreExistingChronicConditionExplanation(state, value) {
      state.benefitsPacket.generalInfo.preExistingChronicConditionExplanation = value;
    },
    updateMaintenanceMedicationsExplanation(state, value) {
      state.benefitsPacket.generalInfo.maintenanceMedicationsExplanation = value;
    },
    updateAdvisedToHaveSurgeryExplanation(state, value) {
      state.benefitsPacket.generalInfo.advisedToHaveSurgeryExplanation = value;
    },
    updateConfinedForTreatmentExplanation(state, value) {
      state.benefitsPacket.generalInfo.confinedForTreatmentExplanation = value;
    },
    updateCurrentPregnanciesExplanation(state, value) {
      state.benefitsPacket.generalInfo.currentPregnanciesExplanation = value;
    },
    updateChronicMissingDaysExplanation(state, value) {
      state.benefitsPacket.generalInfo.chronicMissingDaysExplanation = value;
    },
    // <---- Benefits.CobraEmployees ---->
    updateCobraEmployees(state, value) {
      state.benefitsPacket.cobraCurrrentPeriod = value;
    },
    // <---- Benefits.CobraElectionPeriod ---->
    updateCobraElectionPeriod(state, value) {
      state.benefitsPacket.cobraElectionPeriod = value;
    },
    // <---- Benefits.Signature ---->
    updateBenefitsSignature(state, value) {
      state.benefitsPacket.signature = value;
    },
    // <---- Forgot Password ---->
    updateForgotPasswordDialog(state, value) {
      state.forgotPasswordDialog = value;
    },
    updateForgotPasswordResponse(state, value) {
      state.forgotPasswordResponse = value;
    },
  },
  helperMethods: {

  },
  actions: {
    async sendSignatureRequest({ commit }, formData) {
      try {
        const instance = await axios.create();
        instance.interceptors.response.use((response) => response, (error) => {
          if (error.response.status === 400) {
            console.log(error.response);
          }
          return Promise.reject(error);
        });

        const href = `${base}/admin/SendSignatureRequest`;
        const response = await instance.post(href, formData, {
          crossDomain: true,
          withCredentials: true,
        });

        if (response.status === 204) {
          commit('updateDocSignSuccessful', true);
          commit('updateSendSignatureDialog', false);
          commit('updateDocSignErrorMessage', null);
        }
      } catch (err) {
        if (err.response.status === 401) {
          commit('updateDocSignErrorMessage', 'Unauthorized! Please try logging in again.');
        } else {
          commit('updateDocSignErrorMessage', err.response.data.title);
        }
      }
    },
    async getCompanyStatus({ commit, state }, companyId) {
      const instance = await axios.create();
      instance.interceptors.response.use((response) => response, (error) => {
        if (error.response.status === 401) {
          window.location.href = error.response.headers.location;
        }
        return Promise.reject(error);
      });

      let prospectLoginToken = '';
      if (localStorage.getItem('token')) {
        prospectLoginToken = localStorage.getItem('token');
      }
      if (sessionStorage.getItem('token')) {
        prospectLoginToken = sessionStorage.getItem('token');
      }

      const href = `${base}/register/GetCompanyStatus?companyId=${companyId}`;
      const response = await instance.get(href, {
        headers: {
          Authorization: `Bearer ${prospectLoginToken}`,
        },
      });

      if (response.status === 200) {
        commit('updateCompanyStatus', response.data);
      }
    },
    async forgotPassword({ commit }, email) {
      try {
        const instance = await axios.create();
        instance.interceptors.response.use((response) => response, (error) => {
          if (error.response.status === 401) {
            window.location.href = error.response.headers.location;
          }
          return Promise.reject(error);
        });

        const formData = new FormData();
        formData.append('email', email);

        const href = `${base}/login/ForgotPassword`;
        const response = await instance.post(href, formData);

        if (response.status === 200) {
          commit('updateForgotPasswordResponse', 'Password request sent succesfully!');
          commit('updateForgotPasswordDialog', true);
        }
      } catch (err) {
        if (err.response.status === 401) {
          router.push('/');
        }
        commit('updateForgotPasswordDialog', true);
        commit('updateForgotPasswordResponse', err.response.data);
      }
    },
    async resetPasswordFromToken({ commit }, data) {
      try {
        const { token, password } = data;
        const instance = await axios.create();
        instance.interceptors.response.use((response) => response, (error) => {
          if (error.response.status === 401) {
            window.location.href = error.response.headers.location;
          }
          return Promise.reject(error);
        });

        const formData = new FormData();
        formData.append('token', token);
        formData.append('password', password);

        const href = `${base}/login/SetPasswordFromToken`;
        const response = await instance.put(href, formData);

        if (response.status === 200) {
          commit('updateForgotPasswordResponse', 'Your password has been reset');
          commit('updateForgotPasswordDialog', true);
        }
      } catch (err) {
        if (err.response.status === 400) {
          commit('updateForgotPasswordDialog', true);
          commit('updateForgotPasswordResponse', err.response.data);
        }
        if (err.response.status === 401) {
          router.push('/');
        }
      }
    },
    async getAuditLogs({ commit, state }) {
      try {
        const instance = await axios.create();
        instance.interceptors.response.use((response) => response, (error) => {
          if (error.response.status === 401) {
            window.location.href = error.response.headers.location;
          }
          return Promise.reject(error);
        });

        const href = `${base}/admin/GetAuditLogs`;
        const response = await instance.get(href, {
          withCredentials: true,
        });

        if (response.status === 200) {
          commit('updateAuditLogs', response.data);
        }
      } catch (err) {
        if (err.response.status === 401) {
          router.push('/admin');
        }
      }
    },
    async getAllProspects({ commit, state }) {
      try {
        const instance = await axios.create();
        instance.interceptors.response.use((response) => response, (error) => {
          if (error.response.status === 401) {
            router.push('/admin');
          }
          return Promise.reject(error);
        });

        const href = `${base}/admin/GetAllProspects`;
        const response = await instance.get(href, {
          withCredentials: true,
        });

        if (response.status === 200) {
          const data = response.data.map((obj) => ({ ...obj, loading: false }));
          commit('updateAdminProspects', data);
        }
      } catch (err) {
        if (err.response.status === 401) {
          router.push('/admin');
        }
      }
    },
    async getAllSignedDocuments({ commit, state }) {
      try {
        const instance = await axios.create();
        instance.interceptors.response.use((response) => response, (error) => {
          if (error.response.status === 401) {
            window.location.href = error.response.headers.location;
          }
          return Promise.reject(error);
        });

        const href = `${base}/admin/GetAllSignedDocuments?companyPacketGuid=${state.userInfo.packetGuid}`;
        const response = await instance.get(href, {
          withCredentials: true,
        });

        if (response.status === 200) {
          if (response.data) {
            commit('updateSignedDocuments', response.data);
          }
        }
      } catch (err) {
        if (err.response.status === 401) {
          router.push('/admin');
        }
      }
    },
    async downloadDocument({ state }, data) {
      const { category, name, type } = data;
      try {
        const instance = axios.create();
        instance.interceptors.response.use((response) => response, (error) => {
          if (error.response.status === 401) {
            window.location.href = error.response.headers.location;
          }
          return Promise.reject(error);
        });

        const params = `packetGuid=${state.userInfo.packetGuid}&fileName=${encodeURIComponent(name)}&fileCategory=${category}`;

        const response = await instance.get(`${base}/admin/DownloadUserFile?${params}`, {
          withCredentials: true,
          crossDomain: true,
          responseType: 'arraybuffer',
        });

        if (response.data === 'Forbidden') {
          this.$router.push('/forbidden');
        }
        if (response.status === 200) {
          const mimeType = response.headers['content-type'];
          const blob = new Blob([response.data]);
          const link = document.createElement('a');
          link.href = window.URL.createObjectURL(blob);
          link.download = name;
          link.click();
        }
      } catch (err) {
        if (err.response) {
          console.log('Server error: ', err);
          if (err.response.status === 401) {
            router.push('/admin');
          }
        } else if (err.request) {
          console.log('Network error: ', err);
        } else {
          console.log('Client error: ', err);
        }
      }
    },
    async downloadSignedDocument({ state }, data) {
      const documentId = data.id;
      try {
        const instance = axios.create();
        instance.interceptors.response.use((response) => response, (error) => {
          if (error.response.status === 401) {
            window.location.href = error.response.headers.location;
          }
          return Promise.reject(error);
        });

        const params = `&documentId=${documentId}`;

        const response = await instance.get(`${base}/admin/DownloadSignedDocument?${params}`, {
          withCredentials: true,
          crossDomain: true,
        });

        if (response.data === 'Forbidden') {
          this.$router.push('/forbidden');
        }
        if (response.status === 200) {
          const name = response.data.replace(/^.*[\\/]/, '');
          const blob = await axios.get(response.data, {
            headers: {
              'Content-Type': 'application/octet-stream',
            },
            responseType: 'arraybuffer',
          });
          const link = document.createElement('a');
          link.href = window.URL.createObjectURL(new Blob([blob.data]));
          link.download = name;
          document.body.appendChild(link);
          link.click();
        }
      } catch (err) {
        if (err.response) {
          console.log('Server error: ', err);
          if (err.response.status === 401) {
            router.push('/admin');
          }
        } else if (err.request) {
          console.log('Network error: ', err);
        } else {
          console.log('Client error: ', err);
        }
      }
    },
    async loginToSSO({ commit }) {
      try {
        const instance = axios.create();
        instance.interceptors.response.use((response) => response, (error) => {
          if (error.response.status === 401) {
            window.location.href = error.response.headers.location;
          }
          return Promise.reject(error);
        });

        const response = await instance.get(`${base}/authentication/login`, {
          withCredentials: true,
          crossDomain: true,
        });

        if (response.data === 'Forbidden') {
          this.$router.push('/forbidden');
        }
        if (response.status === 200) {
          commit('updateLoggedInUser', response.data);
          commit('updateValidation', true);
        }
      } catch (err) {
        commit('updateValidation', false);
        if (err.response) {
          console.log('Server error: ', err);
        } else if (err.request) {
          console.log('Network error: ', err);
        } else {
          console.log('Client error: ', err);
        }
      }
    },

    logOutOfSSO() {
      window.location.replace(`${base}/authentication/logout`);
    },

    logOutOfJwt({ commit, state }) {
      if (sessionStorage.getItem('packetGuid')) {
        sessionStorage.removeItem('packetGuid');
        commit('updatedUserInfoImpersonatedFlag', false);
        // set impersonation flag to false in database
        const { packetGuid } = state.userInfo;
        const href = `${base}/admin/ImpersonateProspectUser?companyPacketGuid=${packetGuid}&state=false`;
        const request = axios.get(href, {
          withCredentials: true,
        })
          .then(() => {
            commit('updateAdminProspects', []);
          })
          .catch(console.error);
        router.push('/admin');
        return;
      }

      commit('reset');
      localStorage.removeItem('token');
      sessionStorage.removeItem('token');
      localStorage.removeItem('company');
      router.push('/');
    },

    async loginToProspect({ commit, state }) {
      const href = `${base}/login/CreateToken`;
      try {
        const instance = axios.create();
        instance.defaults.headers.post['Content-Type'] = 'application/json';
        instance.interceptors.response.use((response) => response, (error) => {
          if (error.response.status === 400) {
            commit('updateProspectLoginLoading', false);
            commit('updateProspectLoginErrorResponse', error.response.data);
            commit('updateProspectLoginErrorDialog', true);
          }
          return Promise.reject(error);
        });

        const response = await instance.post(href, state.prospectLoginCreds, {
          crossDomain: true,
        });

        if (response.status === 200) {
          commit('updateProspectLoginLoading', false);
          commit('updateProspectLoginToken', response.data.jwt);
          commit('updateUserCompanies', response.data.companies);
          if (response.data.companies.length > 1) {
            commit('updateCompanyChooserDialog', true);
          }
          commit('updateProspectLoginCreds', {
            email: null,
            password: null,
            remember: state.prospectLoginCreds.remember,
          });
          if (state.prospectLoginCreds.remember) {
            localStorage.setItem('token', state.prospectLoginToken);
          } else {
            sessionStorage.setItem('token', state.prospectLoginToken);
          }
        }
      } catch (err) {
        commit('updateProspectLoginLoading', false);
        console.log(err);
      }
    },

    async inviteProspectUser({ commit, state, dispatch }) {
      const href = `${base}/admin/CreateProspect`;
      try {
        const instance = axios.create();
        instance.interceptors.response.use((response) => response, (error) => {
          if (error.response.status === 400) {
            commit('updateProspectUserInvitationErrorResponse', error.response.data);
            commit('updateProspectUserInvitationErrorDialog', true);
          }
          return Promise.reject(error);
        });

        const response = await instance.post(href, state.prospectUserInvitation, {
          crossDomain: true,
          withCredentials: true,
        });

        if (response.status === 200) {
          dispatch('getAllProspects').then(() => {
            commit('updateProspectUserInvitationErrorResponse', response.status);
            commit('updateProspectUserInvitationErrorDialog', true);
            commit('updateBtnInviteProspectLoading', false);
          });
        }

        if (response.status === 204) {
          commit('updateProspectUserInvitationErrorResponse', response.status);
          commit('updateProspectUserInvitationErrorDialog', true);
          commit('updateBtnInviteProspectLoading', false);
        }
      } catch (err) {
        commit('updateBtnInviteProspectLoading', false);
        if (err.response) {
          console.log('Server error: ', err);
          if (err.response.status === 401) {
            router.push('/admin');
          }
        } else if (err.request) {
          console.log('Network error: ', err);
        } else {
          console.log('Client error: ', err);
        }
      }
    },

    async resendInvite({ commit }, data) {
      const email = data.replace('+', '%2b');
      const href = `${base}/admin/ResendEmailInvite?email=${encodeURIComponent(email)}`;
      try {
        const instance = axios.create();
        instance.interceptors.response.use((response) => response, (error) => {
          if (error.response.status === 400) {
            commit('updateProspectUserInvitationErrorResponse', error.response.data);
            commit('updateProspectUserInvitationErrorDialog', true);
          }
          if (error.response.status === 404) {
            commit('updateProspectUserInvitationErrorResponse', 'No user could be found');
            commit('updateProspectUserInvitationErrorDialog', true);
            commit('UpdateBtnInviteResendLoading', false);
          }
          return Promise.reject(error);
        });

        const response = await instance.get(href, {
          crossDomain: true,
          withCredentials: true,
        });

        // if (response.status === 204) {
        //   commit('UpdateBtnInviteResendLoading', false);
        // }
      } catch (err) {
        commit('UpdateBtnInviteResendLoading', false);
        commit('updateSnackbarMessage', 'Sending invitation failed!');
        commit('updateSnackbarShow', true);
        if (err.response) {
          console.log('Server error: ', err);
          if (err.response.status === 401) {
            router.push('/admin');
          }
        } else if (err.request) {
          console.log('Network error: ', err);
        } else {
          console.log('Client error: ', err);
        }
      }
    },

    async validateEmail({ state }) {
      try {
        const instance = axios.create();
        instance.interceptors.response.use((response) => response, (error) => {
          if (error.response.status === 404) {
            // can't find user message
          }
          return Promise.reject(error);
        });

        const response = await instance.get(`${base}/validate/ValidateEmail?guid=${state.validationGuid}`);

        if (response.status === 204) {
          router.push('/setPassword');
        }

        if (response.status === 200) {
          router.push('/');
        }
      } catch (err) {
        if (err.response) {
          console.log('Server error: ', err);
        } else if (err.request) {
          console.log('Network error: ', err);
        } else {
          console.log('Client error: ', err);
        }
      }
    },

    async savePassword({ commit, state }) {
      try {
        const instance = axios.create();
        instance.interceptors.response.use((response) => response, (error) => {
          if (error.response.status === 400 || error.response.status === 404) {
            commit('updateSetPasswordErrorDialogResponse', error.response.data);
            commit('updateSetPasswordErrorDialog', true);
          }
          return Promise.reject(error);
        });

        const response = await instance.put(`${base}/login/SetPassword?userGuid=${state.validationGuid}&password=${state.setPassword}`);

        if (response.status === 204) {
          router.push('/');
        }

        if (response.status === 200) {
          router.push('/forgotPassword');
        }
      } catch (err) {
        if (err.response) {
          console.log('Server error: ', err);
        } else if (err.request) {
          console.log('Network error: ', err);
        } else {
          console.log('Client error: ', err);
        }
      }
    },

    async validateToken({ commit, state }) {
      try {
        const instance = axios.create();
        instance.interceptors.response.use((response) => response, (error) => {
          if (error.response.status === 401) {
            localStorage.removeItem('token');
            router.push({ name: 'login' });
          }
          return Promise.reject(error);
        });

        let token = localStorage.getItem('token');

        if (token === null) {
          token = sessionStorage.getItem('token');
        }

        const config = {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        };

        const response = await instance.get(`${base}/register/ValidateToken`, config);

        if (response.status === 200) {
          if (response.data.jwt) {
            if (localStorage.getItem('token')) {
              localStorage.setItem('token', response.data.jwt);
            }

            if (sessionStorage.getItem('token')) {
              sessionStorage.setItem('token', response.data.jwt);
            }
            commit('updateProspectLoginToken', response.data.jwt);
            commit('updateUserCompanies', response.data.companies);
          }
          if (router.currentRoute.name !== 'Register' && router.currentRoute.name !== 'Benefits') {
            router.push({ name: 'Register' });
          }
        }
      } catch (err) {
        if (err.response) {
          console.log('Server error: ', err);
        } else if (err.request) {
          console.log('Network error: ', err);
        } else {
          console.log('Client error: ', err);
        }
      }
    },

    async GetProspectPacket({ commit, state }) {
      try {
        const instance = axios.create();
        instance.interceptors.response.use((response) => response, (error) => {
          if (error.response.status === 404) {
            console.log(error.response);
          }
          return Promise.reject(error);
        });

        /* Determine Authentication Method - Admin or Jwt */
        const packetGuid = sessionStorage.getItem('packetGuid');
        const isAdmin = !!packetGuid;

        if (isAdmin) {
          const response = await instance.get(`${base}/register/GetProspectPacket?companyPacketGuid=${packetGuid}`, {
            withCredentials: true,
          });

          if (response.status === 200) {
            commit('updateProspectPacket', response.data);
          }
        } else {
          const companyPacketGuid = localStorage.getItem('company');
          const response = await instance.get(`${base}/register/GetProspectPacket?companyPacketGuid=${companyPacketGuid}`, {
            headers: {
              Authorization: `Bearer ${state.prospectLoginToken}`,
            },
          });

          if (response.status === 200) {
            commit('updateProspectPacket', response.data);
          }
        }
      } catch (err) {
        if (err.response) {
          console.log('Server error: ', err);
          if (err.response.status === 401) {
            router.push('/');
          }
        } else if (err.request) {
          console.log('Network error: ', err);
        } else {
          console.log('Client error: ', err);
        }
      }
    },
    async GetBenefitsPacket({ commit, state }) {
      try {
        const instance = axios.create();
        instance.interceptors.response.use((response) => response, (error) => {
          if (error.response.status === 404) {
            console.log(error.response);
          }
          return Promise.reject(error);
        });

        /* Determine Authentication Method - Admin or Jwt */
        const packetGuid = sessionStorage.getItem('packetGuid');
        const isAdmin = !!packetGuid;

        if (isAdmin) {
          const response = await instance.get(`${base}/register/GetBenefitsPacket?companyPacketGuid=${packetGuid}`, {
            withCredentials: true,
          });

          if (response.status === 200) {
            commit('updateBenefitsPacket', response.data);
          }
        } else {
          const companyPacketGuid = localStorage.getItem('company');
          const response = await instance.get(`${base}/register/GetBenefitsPacket?companyPacketGuid=${companyPacketGuid}`, {
            headers: {
              Authorization: `Bearer ${state.prospectLoginToken}`,
            },
          });

          if (response.status === 200) {
            commit('updateBenefitsPacket', response.data);
          }
        }
      } catch (err) {
        if (err.response) {
          console.log('Server error: ', err);
          if (err.response.status === 401) {
            router.push('/');
          }
        } else if (err.request) {
          console.log('Network error: ', err);
        } else {
          console.log('Client error: ', err);
        }
      }
    },
    async GetUserProspectDocuments({ commit, state }) {
      try {
        const instance = axios.create();
        // instance.defaults.headers.post['Content-Type'] = 'application/json';
        instance.interceptors.response.use((response) => response, (error) => {
          if (error.response.status === 400) {
            console.log(error.response);
          }
          return Promise.reject(error);
        });

        /* Determine Authentication Method - Admin or Jwt */
        const packetGuid = sessionStorage.getItem('packetGuid');
        const isAdmin = !!packetGuid;

        let response = null;

        if (isAdmin) {
          const href = `${base}/register/GetUserDocuments?type=Prospect&companyPacketGuid=${packetGuid}`;
          const headers = {
            'Content-Type': 'multipart/form-data',
          };
          response = await instance.get(href, {
            crossDomain: true,
            withCredentials: true,
          });
        } else {
          const userPacketGuid = localStorage.getItem('company');
          const href = `${base}/register/GetUserDocuments?type=Prospect&companyPacketGuid=${userPacketGuid}`;
          const headers = {
            'Content-Type': 'multipart/form-data',
            Authorization: `Bearer ${state.prospectLoginToken}`,
          };
          response = await instance.get(href, {
            crossDomain: true,
            headers,
          });
        }

        if (response.status === 200) {
          commit('updateProspectDocuments', response.data);
        }
      } catch (err) {
        console.log(err);
        if (err.response.status === 401) {
          router.push('/');
        }
      }
    },
    async GetUserBenefitDocuments({ commit, state }) {
      try {
        const instance = axios.create();
        // instance.defaults.headers.post['Content-Type'] = 'application/json';
        instance.interceptors.response.use((response) => response, (error) => {
          if (error.response.status === 400) {
            console.log(error.response);
          }
          return Promise.reject(error);
        });

        /* Determine Authentication Method - Admin or Jwt */
        const packetGuid = sessionStorage.getItem('packetGuid');
        const isAdmin = !!packetGuid;

        let response = null;

        if (isAdmin) {
          const href = `${base}/register/GetUserDocuments?type=Benefits&companyPacketGuid=${packetGuid}`;
          const headers = {
            'Content-Type': 'multipart/form-data',
          };
          response = await instance.get(href, {
            crossDomain: true,
            withCredentials: true,
          });
        } else {
          const userPacketGuid = localStorage.getItem('company');
          const href = `${base}/register/GetUserDocuments?type=Benefits&companyPacketGuid=${userPacketGuid}`;
          const headers = {
            'Content-Type': 'multipart/form-data',
            Authorization: `Bearer ${state.prospectLoginToken}`,
          };
          response = await instance.get(href, {
            crossDomain: true,
            headers,
          });
        }

        if (response.status === 200) {
          commit('updateBenefitsDocuments', response.data);
        }
      } catch (err) {
        console.log(err);
        if (err.response.status === 401) {
          router.push('/');
        }
      }
    },
    async DeleteFile({ state, dispatch }, data) {
      try {
        const instance = axios.create();
        // instance.defaults.headers.post['Content-Type'] = 'application/json';
        instance.interceptors.response.use((response) => response, (error) => {
          if (error.response.status === 400) {
            console.log(error.response);
          }
          return Promise.reject(error);
        });

        const { id, name } = data;
        const formData = new FormData();
        formData.append('id', id);
        formData.append('name', name);

        /* Determine Authentication Method - Admin or Jwt */
        const packetGuid = sessionStorage.getItem('packetGuid');
        const isAdmin = !!packetGuid;

        let response = null;

        if (isAdmin) {
          const href = `${base}/register/DeleteDocument?companyPacketGuid=${packetGuid}`;
          const headers = {
            'Content-Type': 'multipart/form-data',
          };
          response = await instance.delete(href, {
            crossDomain: true,
            withCredentials: true,
            headers,
            data: formData,
          });
        } else {
          const userPacketGuid = localStorage.getItem('company');
          const href = `${base}/register/DeleteDocument?companyPacketGuid=${userPacketGuid}`;
          const headers = {
            'Content-Type': 'multipart/form-data',
            Authorization: `Bearer ${state.prospectLoginToken}`,
          };
          response = await instance.delete(href, {
            crossDomain: true,
            headers,
            data: formData,
          });
        }

        if (response.status === 204) {
          await dispatch('GetUserBenefitDocuments');
          await dispatch('GetUserProspectDocuments');
        }
      } catch (err) {
        console.log(err);
        if (err.response.status === 401) {
          router.push('/');
        }
      }
    },
    async uploadDocument({ commit, state, dispatch }, { file, progress }) {
      try {
        const instance = axios.create();
        // instance.defaults.headers.post['Content-Type'] = 'application/json';
        instance.interceptors.response.use((response) => response, (error) => {
          if (error.response.status === 400) {
            console.log(error.response);
          }
          return Promise.reject(error);
        });

        /* Determine Authentication Method - Admin or Jwt */
        const packetGuid = sessionStorage.getItem('packetGuid');
        const isAdmin = !!packetGuid;

        const formData = new FormData();
        formData.append('documents', file.document);
        formData.append('category', file.category);
        formData.append('type', file.type);
        formData.append('action', file.action);

        let response = null;

        if (isAdmin) {
          const headers = {
            'Content-Type': 'multipart/form-data',
          };
          const href = `${base}/register/UploadDocuments?companyPacketGuid=${packetGuid}`;
          response = await instance.post(href, formData, {
            crossDomain: true,
            withCredentials: true,
            headers,
            onUploadProgress: (event) => progress((event.loaded * 100) / event.total),
          });
        } else {
          const headers = {
            'Content-Type': 'multipart/form-data',
            Authorization: `Bearer ${state.prospectLoginToken}`,
          };
          const userPacketGuid = localStorage.getItem('company');
          const href = `${base}/register/UploadDocuments?companyPacketGuid=${userPacketGuid}`;
          response = await instance.post(href, formData, {
            crossDomain: true,
            headers,
            onUploadProgress: (event) => progress((event.loaded * 100) / event.total),
          });
        }

        // Update document file name on successful upload
        if (response.status === 204) {
          if (file.type === 'Benefits') {
            if (file.action === 'insert') {
              await dispatch('GetUserBenefitDocuments');
              return;
            }

            const { documents } = state.benefitsPacket;
            const document = documents.find((x) => x.category === file.category);
            if (document) {
              document.name = file.document.name;
              commit('updateBenefitsDocuments', documents);
            } else {
              documents.push({
                category: file.category,
                name: file.document.name,
                type: file.type,
              });
            }
          }

          if (file.type === 'Prospect') {
            if (file.action === 'insert') {
              await dispatch('GetUserProspectDocuments');
              return;
            }
            const { documents } = state.prospectPacket;
            const document = documents.find((x) => x.category === file.category);

            if (document) {
              document.name = file.document.name;
              commit('updateProspectDocuments', documents);
            } else {
              documents.push({
                category: file.category,
                name: file.document.name,
                type: file.type,
              });
            }
          }
        }
      } catch (err) {
        // console.log(err);
        if (err.response.status === 401) {
          router.push('/');
        }
        if (err.response.status === 413 || Object.values(err.response.data.errors)[0][0].includes('Request body too large')) {
          commit('updateFileSizeDialog', true);
        }
      }
    },
    async createErrorLog({ commit, state }) {
      const { auditLog } = state;
      const instance = axios.create();
      instance.defaults.headers.post['Content-Type'] = 'application/json';

      const formData = new FormData();
      formData.append('Message', auditLog.message);
      formData.append('Data', auditLog.data);
      formData.append('ErrorCode', auditLog.errorCode);
      formData.append('CompanyPacketGuid', auditLog.companyPacketGuid);

      const href = `${base}/register/CreateErrorLog`;
      const response = await axios.post(href, formData, {
        crossDomain: true,
        headers: {
          Authorization: `Bearer ${state.prospectLoginToken}`,
        },
      });
    },
    async updatePacketInfo({ commit, state, dispatch }) {
      const currentAuditLog = {};
      try {
        const instance = axios.create();
        instance.defaults.headers.post['Content-Type'] = 'application/json';
        instance.interceptors.response.use((response) => response, (error) => {
          if (error.response.status === 400 || error.response.status === 404) {
            // commit('updateSetPasswordErrorDialogResponse', error.response.data);
            // commit('updateSetPasswordErrorDialog', true);
          }
          return Promise.reject(error);
        });

        /* Determine Authentication Method - Admin or Jwt */
        const packetGuid = sessionStorage.getItem('packetGuid');
        const isAdmin = !!packetGuid;

        const headers = {
          Authorization: `Bearer ${state.prospectLoginToken}`,
        };

        if (isAdmin) {
          const responseProspect = await instance.put(`${base}/register/UpdateProspectPacket?companyPacketGuid=${packetGuid}`, state.prospectPacket, {
            crossDomain: true,
            withCredentials: true,
          });

          const responseBenefits = await instance.put(`${base}/register/UpdateBenefitsPacket?companyPacketGuid=${packetGuid}`, state.benefitsPacket, {
            crossDomain: true,
            withCredentials: true,
          });

          commit('updateSnackbarMessage', 'Data has been saved!');
          commit('updateSnackbarShow', true);
        } else {
          const companyPacketGuid = localStorage.getItem('company');
          currentAuditLog.companyPacketGuid = companyPacketGuid;
          currentAuditLog.data = JSON.stringify(state.prospectPacket);
          const responseProspect = await instance.put(`${base}/register/UpdateProspectPacket?companyPacketGuid=${companyPacketGuid}`, state.prospectPacket, {
            crossDomain: true,
            headers,
          });

          currentAuditLog.data = JSON.stringify(state.benefitsPacket);
          if (state.prospectPacket.flags.hasBenefitPacket) {
            const responseBenefits = await instance.put(`${base}/register/UpdateBenefitsPacket?companyPacketGuid=${companyPacketGuid}`, state.benefitsPacket, {
              crossDomain: true,
              headers,
            });
          }

          commit('updateSnackbarMessage', 'Data has been saved!');
          commit('updateSnackbarShow', true);
        }
      } catch (err) {
        if (err.response) {
          console.log('Server error: ', err);
          currentAuditLog.message = JSON.stringify(err.response.data);
          currentAuditLog.errorCode = err.response.status;
          commit('updateAuditLog', currentAuditLog);
          dispatch('createErrorLog');
          if (err.response.status === 401) {
            commit('goToStep', 0);
          }
        } else if (err.request) {
          console.log('Network error: ', err);
        } else {
          console.log('Client error: ', err);
        }
      }
    },
    async SetImpersonationFlag({ commit, state }) {
      try {
        const instance = axios.create();
        instance.interceptors.response.use((response) => response, (error) => {
          if (error.response.status === 404) {
            console.log(error.response);
          }
          return Promise.reject(error);
        });

        const { packetGuid } = state.userInfo;

        const response = await instance.get(`${base}/admin/ImpersonateProspectUser?companyPacketGuid=${packetGuid}&state=true`, {
          withCredentials: true,
        });

        if (response.status === 204) {
          // continue to impersonation
          commit('updatedUserInfoImpersonatedFlag', true);
        }

        if (response.status === 200) {
          // something went wrong
          commit('updateSnackbarMessage', 'Impersonation failed. Please contact IT');
          commit('updateSnackbarShow', true);
        }
      } catch (err) {
        commit('updateSnackbarMessage', 'Data error. Please contact support!');
        commit('updateSnackbarShow', true);
        if (err.response) {
          console.log('Server error: ', err);
          if (err.response.status === 401) {
            router.push('/admin');
          }
        } else if (err.request) {
          console.log('Network error: ', err);
        } else {
          console.log('Client error: ', err);
        }
      }
    },
    async AdminGetProspectPacket({ commit, state }) {
      try {
        const instance = axios.create();
        instance.interceptors.response.use((response) => response, (error) => {
          if (error.response.status === 404) {
            console.log(error.response);
          }
          return Promise.reject(error);
        });

        const { packetGuid } = state.userInfo;

        const response = await instance.get(`${base}/register/GetProspectPacket?companyPacketGuid=${packetGuid}`, {
          withCredentials: true,
        });

        if (response.status === 200) {
          commit('updateProspectPacket', response.data);
        }
      } catch (err) {
        commit('updateSnackbarMessage', 'Data error. Please contact support!');
        commit('updateSnackbarShow', true);
        if (err.response) {
          console.log('Server error: ', err);
          if (err.response.status === 401) {
            router.push('/admin');
          }
        } else if (err.request) {
          console.log('Network error: ', err);
        } else {
          console.log('Client error: ', err);
        }
      }
    },
    async AdminGetBenefitsPacket({ commit, state }) {
      try {
        const instance = axios.create();
        instance.interceptors.response.use((response) => response, (error) => {
          if (error.response.status === 404) {
            console.log(error.response);
          }
          return Promise.reject(error);
        });

        const { packetGuid } = state.userInfo;

        const response = await instance.get(`${base}/register/GetBenefitsPacket?companyPacketGuid=${packetGuid}`, {
          withCredentials: true,
        });

        if (response.status === 200) {
          commit('updateBenefitsPacket', response.data);
        }
      } catch (err) {
        commit('updateSnackbarMessage', 'Data error. Please contact support!');
        commit('updateSnackbarShow', true);
        if (err.response) {
          console.log('Server error: ', err);
          if (err.response.status === 401) {
            router.push('/admin');
          }
        } else if (err.request) {
          console.log('Network error: ', err);
        } else {
          console.log('Client error: ', err);
        }
      }
    },
    async SignBenefitsDocuments({ commit, state }) {
      try {
        commit('updateBenefitsSignAndReviewBtn', true);
        const instance = axios.create();
        instance.interceptors.response.use((response) => response, (error) => {
          if (error.response.status === 404) {
            console.log(error.response);
          }
          return Promise.reject(error);
        });

        const headers = {
          Authorization: `Bearer ${state.prospectLoginToken}`,
        };

        const companyPacketGuid = localStorage.getItem('company');
        let requestUrl = `${base}/register/SignBenefitsDocuments?companyPacketGuid=${companyPacketGuid}`;

        if (state.signatureRequestEmail) {
          requestUrl += `&email=${state.signatureRequestEmail}`;
        }

        const response = await instance.get(requestUrl, {
          headers,
        });

        if (response.status === 200) {
          commit('updateBenefitsSignAndReviewBtn', false);
          // window.location.href = response.data.location;
          return response.data;
        }
        if (response.status === 204) {
          commit('updateBenefitsSignAndReviewBtn', false);
          router.push('/thanks');
        }
      } catch (err) {
        if (err.response) {
          if (err.response.status === 401) {
            commit('updateBenefitsSignAndReviewBtn', false);
            commit('updateSnackbarMessage', 'Unauthorized! Please try logging in again.');
            commit('updateSnackbarShow', true);
          } else {
            commit('updateBenefitsSignAndReviewBtn', false);
            commit('updateSnackbarMessage', 'Error applying for signature!');
            commit('updateSnackbarShow', true);
          }
          console.log('Server error: ', err);
        } else if (err.request) {
          console.log('Network error: ', err);
        } else {
          console.log('Client error: ', err);
        }
      }

      return null;
    },
    async invokeSignRegistrationDocuments({ commit, state }) {
      try {
        commit('updateBtnSignAndReviewLoading', true);
        const instance = axios.create();
        instance.interceptors.response.use((response) => response, (error) => {
          if (error.response.status === 404) {
            console.log(error.response);
          }
          return Promise.reject(error);
        });

        const headers = {
          Authorization: `Bearer ${state.prospectLoginToken}`,
        };

        const companyPacketGuid = localStorage.getItem('company');
        let requestUrl = `${base}/register/SignRegistrationDocuments?companyPacketGuid=${companyPacketGuid}`;

        if (state.signatureRequestEmail) {
          requestUrl += `&email=${state.signatureRequestEmail}`;
        }

        const response = await instance.get(requestUrl, {
          headers,
        });

        if (response.status === 200) {
          commit('updateBtnSignAndReviewLoading', false);
          return response.data;
        }
        if (response.status === 204) {
          commit('updateBtnSignAndReviewLoading', false);
          router.push('/thanks');
        }
      } catch (err) {
        if (err.response) {
          if (err.response.status === 401) {
            commit('updateBtnSignAndReviewLoading', false);
            commit('updateSnackbarMessage', 'Unauthorized! Please try logging in again.');
            commit('updateSnackbarShow', true);
          } else {
            commit('updateBtnSignAndReviewLoading', false);
            commit('updateSnackbarMessage', 'Error applying for signature!');
            commit('updateSnackbarShow', true);
          }
          console.log('Server error: ', err);
        } else if (err.request) {
          console.log('Network error: ', err);
        } else {
          console.log('Client error: ', err);
        }
      }

      return null;
    },
    async addCompanyToUser({ dispatch }, data) {
      try {
        const { name, userGuid } = data;
        const instance = axios.create();
        instance.interceptors.response.use((response) => response, (error) => {
          if (error.response.status === 404) {
            console.log(error.response);
          }
          return Promise.reject(error);
        });

        const formData = new FormData();
        formData.append('userGuid', userGuid);
        formData.append('companyName', name);

        const href = `${base}/admin/AddCompany`;
        const response = await instance.post(href, formData, {
          crossDomain: true,
          withCredentials: true,
        });

        if (response.status === 200) {
          await dispatch('getAllProspects');
        }
      } catch (err) {
        console.log(err);
      }
    },
  },
});

export default localStore;
